import { RecursivePartial } from '@models/base';
import { BaseTaskAction, TaskActionType } from './_base-task-action';

export class TaskActionStartDate extends BaseTaskAction {
    type: TaskActionType.StartDate = TaskActionType.StartDate;
    startDate?: Date;
    startDateOld?: Date;

    constructor(json?: RecursivePartial<TaskActionStartDate>) {
        super(json);
        this.parseTaskActionStartDate(json || {});
    }

    parse(json: RecursivePartial<TaskActionStartDate>): TaskActionStartDate {
        super.parse(json);
        this.parseTaskActionStartDate(json);
        return this;
    }

    private parseTaskActionStartDate(json: RecursivePartial<TaskActionStartDate>): void {
        TaskActionStartDate.assignDates<TaskActionStartDate>(this, json, ['startDate', 'startDateOld']);
    }
}
